const Spinner = (props) => (
  <svg
    viewBox="0 0 28 28"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <circle cx="14" cy="6" r="2" />
      <circle cx="14" cy="22" r="2" />
      <circle cx="22" cy="14" r="2" />
      <circle cx="6" cy="14" r="2" />
      <circle cx="19.6568" cy="19.6569" r="2" />
      <circle cx="8.3432" cy="8.34314" r="2" />
      <circle cx="8.34314" cy="19.6568" r="2" />
    </g>
  </svg>
);

export default Spinner;
